import { SeededRandom } from "../core/SeededRandom";

export const TORCH_FRAME_WIDTH = 48;
export const TORCH_FRAME_HEIGHT = 72;
export const TORCH_FRAME_COUNT = 3;

export class TorchSpriteGenerator {
  public constructor(private readonly seed: string) {}

  public createAtlas(): HTMLCanvasElement {
    const canvas = document.createElement("canvas");
    canvas.width = TORCH_FRAME_WIDTH * TORCH_FRAME_COUNT;
    canvas.height = TORCH_FRAME_HEIGHT;
    const context = canvas.getContext("2d");
    if (!context) throw new Error("Canvas 2D context is unavailable");
    context.imageSmoothingEnabled = false;
    const random = new SeededRandom(`${this.seed}:wall-torches`);
    for (let frame = 0; frame < TORCH_FRAME_COUNT; frame += 1) {
      context.save();
      context.translate(frame * TORCH_FRAME_WIDTH, 0);
      this.drawFrame(context, frame, random);
      context.restore();
    }
    return canvas;
  }

  private drawFrame(
    context: CanvasRenderingContext2D,
    frame: number,
    random: SeededRandom,
  ): void {
    const sway = [-2, 2, 0][frame] ?? 0;
    context.clearRect(0, 0, TORCH_FRAME_WIDTH, TORCH_FRAME_HEIGHT);

    context.fillStyle = "rgba(0,0,0,.32)";
    context.fillRect(12, 30, 27, 7);
    context.fillStyle = "#23221d";
    context.fillRect(15, 28, 21, 5);
    context.fillStyle = "#6f6250";
    context.fillRect(17, 29, 17, 2);

    context.fillStyle = "#3a2117";
    context.fillRect(21, 34, 8, 31);
    context.fillStyle = "#8b4c2c";
    context.fillRect(23, 35, 4, 29);
    context.fillStyle = "#21130f";
    for (let y = 39; y < 64; y += 7) context.fillRect(20, y, 10, 3);

    context.fillStyle = "#df4d16";
    context.beginPath();
    context.moveTo(16 + sway, 31);
    context.lineTo(19 + sway, 16 + frame * 2);
    context.lineTo(24 + sway, 5 + (frame === 1 ? 5 : 0));
    context.lineTo(30 + sway, 17 - frame * 2);
    context.lineTo(34 + sway, 31);
    context.closePath();
    context.fill();
    context.fillStyle = "#ff9d22";
    context.beginPath();
    context.moveTo(20 + sway, 31);
    context.lineTo(23 + sway, 18);
    context.lineTo(27 + sway, 11 + frame * 3);
    context.lineTo(31 + sway, 31);
    context.closePath();
    context.fill();
    context.fillStyle = "#ffe17a";
    context.fillRect(24 + sway, 23 - frame, 4, 9 + frame);

    context.fillStyle = frame === 1 ? "#f9b449" : "#d86a22";
    for (let ember = 0; ember < 3; ember += 1) {
      context.fillRect(
        18 + random.int(0, 14) + sway,
        5 + random.int(0, 12),
        2,
        2,
      );
    }
  }
}
